<section class="update-order-dialog">
  <div mat-dialog-title class="dialog-header">
    <span class="trademark-name">
      <ng-container i18n="@@UpdateOrderComponentTitle"
        >Update Watch Order</ng-container
      >
      "{{ this.order.trademarkName }}"
    </span>
    <button
      mat-icon-button
      mat-dialog-close
      class="material-icons floatRight close-btn"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog-content">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="0ms"
      class="tab-group"
      [(selectedIndex)]="focusTabIndex"
    >
      <mat-tab
        id="product-brand-info"
        label="Product & Brand Info"
        i18n-label="@@UpdateOrderComponentProductAndBrandLabel"
        value="productAndBrand"
      >
        <app-product-brand-info
          (notifyProductFormValidation)="validateForm($event)"
        ></app-product-brand-info>
      </mat-tab>
      @if (showWatchedRegisterTab) {
      <div>
        <mat-tab
          id="watched-register"
          i18n-label="@@UpdateOrderComponentWatchedRegistersLabel"
          label="Watched Registers"
          value="watchedRegisters"
          [disabled]="watchedRegisterTabDisabled"
        >
          <app-watched-register></app-watched-register>
        </mat-tab>
      </div>
      }
      <mat-tab
        id="reference-info"
        i18n-label="@@UpdateOrderComponentReferenceInfoLabel"
        label="Reference Info"
        value="referenceInfo"
        [disabled]="referenceInfoTabDisabled"
      >
        <app-reference-info></app-reference-info>
      </mat-tab>
      @if (showFullTextLookupTab) {
      <mat-tab
        id="full-text-lookup"
        i18n-label="@@UpdateOrderComponentFullTextlookupLabel"
        label="Full Text Lookup"
        value="fullTextlookup"
        [disabled]="fullTextLookupTabDisabled"
      >
        <app-full-text-lookup></app-full-text-lookup>
      </mat-tab>
      }
    </mat-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      id="cancel-button"
      class="cdx-but-md"
      color="primary"
      (click)="cancel()"
      mat-stroked-button
      mat-dialog-close
      i18n="@@UpdateOrderComponentCancelButton"
    >
      Cancel
    </button>
    <button
      id="save-button"
      mat-flat-button
      color="primary"
      class="marginBottom"
      [disabled]="saveButtonDisabled"
      (click)="updateOrder()"
      i18n="@@UpdateOrderComponentSaveButton"
    >
      Update Order
    </button>
  </mat-dialog-actions>
</section>
